'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _translate = require('../../helpers/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaintersCheckoutBanner = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PaintersCheckoutBanner, _React$Component);

  function PaintersCheckoutBanner() {
    (0, _classCallCheck3.default)(this, PaintersCheckoutBanner);
    return (0, _possibleConstructorReturn3.default)(this, (PaintersCheckoutBanner.__proto__ || (0, _getPrototypeOf2.default)(PaintersCheckoutBanner)).apply(this, arguments));
  }

  (0, _createClass3.default)(PaintersCheckoutBanner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          code = _props.config.store.code;


      return _react2.default.createElement(
        'div',
        null,
        this.props.config.store.textBannerActive && _react2.default.createElement(
          'div',
          { styleName: 'specialnotice' },
          _react2.default.createElement(
            'p',
            null,
            (0, _translate.contextualTranslation)(t, code, 'spree.show_text_banner_text')
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: this.props.cartStyle },
          _react2.default.createElement(
            'header',
            { styleName: 'checkoutBanner', className: 'clearfix' },
            _react2.default.createElement(
              'div',
              { className: 'container' },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'checkoutBanner__inner' },
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'checkoutBanner__text', className: 't-title' },
                    this.props.title
                  ),
                  this.props.children
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PaintersCheckoutBanner;
}(_react2.default.Component), _class2.propTypes = {
  title: _react.PropTypes.string.isRequired
}, _class2.defaultProps = {
  cartStyle: ''
}, _temp)) || _class) || _class);
exports.default = PaintersCheckoutBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/CheckoutBanner/painters.js
// module id = 2267
// module chunks = 0